import { FormItemType } from '@/api/model/formItemType';

export function isSectionFormItemType(itemType: FormItemType): boolean {
  return itemType === FormItemType.Section;
}

export function isSubItemCollectionFormItemType(itemType: FormItemType): boolean {
  return itemType === FormItemType.SubItemCollection;
}

/** True for any FormItemType that holds child FormItems (Section or SubItemCollection). */
export function isContainerFormItemType(itemType: FormItemType): boolean {
  return isSectionFormItemType(itemType) || isSubItemCollectionFormItemType(itemType);
}

// Despite the name, SubItemCollection is fully interactive - it's grouped here because, like
// Section/Instructions, it has no scalar value/schema entry of its own and renders without
// FieldContent's generic label chrome.
export function isDisplayOnlyFormItemType(itemType: FormItemType): boolean {
  return itemType === FormItemType.Section || itemType === FormItemType.Instructions || itemType === FormItemType.SubItemCollection;
}
